import { adminPath, type AdminClient } from '../core/index.js'
import type { ScorePreview } from '../scoring/index.js'
import type { BehaviorsApi } from './components/behaviorsApi.js'
import type { BehaviorEvent, BehaviorsState } from './types.js'

/** The behaviors module's admin calls: the behaviors manager for any client, and a worker's reported behavior events. */
export interface BehaviorsAdminApi {
  /** The behaviors manager for one client, through the platform-admin routes. */
  behaviorsFor(clientId: string): BehaviorsApi
  /** Reported custom behavior events, most recent first. */
  workerBehaviorEvents(clientId: string, workerId: string): Promise<BehaviorEvent[]>
}

export function createBehaviorsAdminApi(client: AdminClient): BehaviorsAdminApi {
  return {
    behaviorsFor: (clientId) => {
      const base = `${adminPath.client(clientId)}/behaviors`
      return {
        queryKey: ['admin', 'behaviors', clientId],
        load: () => client.call<BehaviorsState>('GET', base),
        saveMaster: (settings) => client.call<BehaviorsState>('PUT', `${base}/master`, { settings }),
        saveFacility: (facilityId, overrides) => client.call<BehaviorsState>('PUT', `${base}/facilities/${encodeURIComponent(facilityId)}`, { overrides }),
        createCustom: (input) => client.call<BehaviorsState>('POST', `${base}/custom`, input),
        updateCustom: (key, changes) => client.call<BehaviorsState>('PATCH', `${base}/custom/${encodeURIComponent(key)}`, changes),
        deleteCustom: (key) => client.call<BehaviorsState>('DELETE', `${base}/custom/${encodeURIComponent(key)}`),
        preview: (facilityId, request) => client.call<ScorePreview>('POST', `${adminPath.facility(clientId, facilityId)}/scores/preview`, request),
      }
    },
    workerBehaviorEvents: (clientId, workerId) => client.call('GET', `${adminPath.worker(clientId, workerId)}/behavior-events`),
  }
}
